import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export function RoutesListener(_ref) {
  var onLocationChanged = _ref.onLocationChanged;
  var location = useLocation();
  useEffect(function () {
    if (onLocationChanged) {
      onLocationChanged(location);
    }
  }, [location, onLocationChanged]);
  return null;
}